import { keys, values, zipWith } from 'ramda'

import { Metrics } from '../../store/store.types'
import { getAnnotationsPerClassMetric } from '../../utils/metric'
import useStyles from './AnnotationsCount.styles'

type AnnotationsCountProps = {
  metrics: Metrics
}

const AnnotationsCount = ({ metrics }: AnnotationsCountProps) => {
  const classes = useStyles()

  const annotationsPerClassData =
    metrics && getAnnotationsPerClassMetric(metrics)?.data

  return annotationsPerClassData ? (
    <>
      {zipWith(
        (clazz, count) => (
          <div className={classes.badge} key={`badge-${clazz}-${count}`}>
            {count} {clazz}
          </div>
        ),
        keys(annotationsPerClassData),
        values(annotationsPerClassData)
      )}
    </>
  ) : null
}

export default AnnotationsCount
